import styled from "styled-components";


export const DevLogo = styled.div`
    display: flex;
    margin:2.5px;
`;

export const LogoText = styled.div`
    align-self: flex-end;
    font-weight: light;
`;

export const Image = styled.img`
    width: 40px;
    height: 40px;
    `;

export const Prime = styled.span`
    margin-left: 3px;
    text-align: center;
    color:  #FFC000;
`;
export const Dev = styled.span`
`;